/**
 * Created by WebStorm.
 * User: Mehedi Hasan
 * Date: 25 Dec 2024
 * Time: 4:45 PM
 * Email: mdmehedihasanroni28@gmail.com
 */

import axios from "axios";
import * as URL from "../../helpers/Constants";

export default class PMSRoleService {

    static getAllPMSRole(pharmacyId, params) {
        return axios.get(`${URL.GET_ALL_PMS_ROLE}/${pharmacyId}`, {
            params, ...PMSRoleService.getAuthHeader()
        });
    }

    static getAllPMSPermission() {
        return axios.get(URL.GET_ALL_PMS_PERMISSION, {
                ...PMSRoleService.getAuthHeader()
            }
        );
    }

    static getPMSRoleById(roleId, pharmacyId) {
        return axios.get(`${URL.GET_PMS_ROLE_BY_ID}/${roleId}/${pharmacyId}`, {
                ...PMSRoleService.getAuthHeader()
            }
        );
    }

    static createPMSRole(pharmacyId, data) {
        return axios.post(`${URL.ADD_PMS_ROLE}/${pharmacyId}`, data, {
                ...PMSRoleService.getAuthHeader()
            }
        );
    }

    static updatePMSRole(roleId, pharmacyId, data) {
        return axios.put(`${URL.EDIT_PMS_ROLE}/${roleId}/${pharmacyId}`, data, {
                ...PMSRoleService.getAuthHeader()
            }
        );
    }

    static getAuthHeader() {
        const accessToken = localStorage.getItem("oushodsheba_access_token");
        return {headers: {"Authorization": `Bearer ${accessToken}`}};
    }

}
